<template>
  <li :class="paymentItemClass">
    <div class="item-body" @click="handleShowContractDetail">
      <Row :gutter="32">
        <Col :span="8">
          <p class="label">{{isBalance ? '客户用户名' : '公司信息'}}</p>
          <p class="value">{{item.company_name}}</p>
        </Col>
        <Col :span="10">
          <p class="label">{{isBalance ? '订单' : '账单'}}编号</p>
          <p class="value">{{isBalance ? item.journal_number : item.billing_number}}</p>
        </Col>
        <Col :span="6">
          <p class="label">应收总金额</p>
          <p class="value">
            ¥ {{isBalance ? item.received_amount : item.amount}}元
          </p>
        </Col>
      </Row>
    </div>
    <div class="item-footer flex flex--justify-between flex--align-center">
      <div class="time">创建时间：{{item.create_time}}</div>
      <div :class="detailClasses">
        <v-icon type="iconerror_outline-24px1"
                v-if="item.pay_flag === 'Y'"></v-icon>
        <Select v-if="editable" :value="isBalance ? item.journal_status : item.billing_status"
                @on-change="handleStatusChange"
                transfer>
          <Option value="TOPAID">{{'待支付'}}</Option>
          <Option value="PAID">{{'已支付'}}</Option>
          <Option value="OVERDUE" v-if="!isBalance">{{'已逾期'}}</Option>
        </Select>
        <div class="ivu-select" style="padding-left: 8px; line-height: 24px" v-else>{{ isBalance ? statusMapping[item.journal_status] : statusMapping[item.billing_status] }}</div>
      </div>
    </div>
    <div class="item-remark">
      <Poptip trigger="hover"
              v-if="item.comment"
              placement="top-end"
              title="备注"
              transfer
              popper-class="payment-item-remark-poptip"
              :content="item.comment">
        <v-icon type="iconchat-24px"></v-icon>
        <div slot="title" class="flex flex--justify-between flex--align-center">
          <h3>备注</h3>
          <p v-if="editable" @click="handleClearRemark">清空</p>
        </div>
        <div style="white-space: normal" slot="content">{{item.comment}}</div>
      </Poptip>
      <v-icon type="iconadd_comment-24px1"
              @click.stop.native="handleShowRemark"
              v-else-if="editable"></v-icon>
    </div>
    <div class="item-changed" v-if="item.isChanged">
      <div class="item-changed-bg"></div>
    </div>
  </li>
</template>

<script>
import { updateJournal, updateBilling } from '@/api/settlement/payment';
const statusMapping = {
  'PAID': '已支付',
  'TOPAID': '待支付',
  'OVERDUE': '已逾期',
}

export default {
  name: 'paymentItem',
  props: {
    contractTypeMap: Object,
    item: {
      default() {
        return {};
      },
      type: Object,
    },
    originItem: {
      default() {
        return {};
      },
      type: Object,
    },
    isBalance: Boolean,
    editable: Boolean,
  },
  data() {
    return {
      statusMapping
    }
  },
  computed: {
    detailClasses() {
      const classes = ['detail'];
      if (this.item.journal_status) {
        classes.push(this.item.journal_status.toLowerCase());
      }
      if (this.item.billing_status) {
        classes.push(this.item.billing_status.toLowerCase());
      }
      return classes;
    },
    paymentItemClass() {
      const classes = ['item'];
      if (!this.isBalance) {
        classes.push('billing');
      }
      return classes;
    },
  },
  methods: {
    handleShowRemark() {
      this.$emit('on-remark-show');
      this.remarkVisible = true;
    },
    handleStatusChange(val) {
      const data = {
        ...this.item,
      };
      if (this.isBalance) {
        data.journal_status = val;
      } else {
        data.billing_status = val;
      }
      this.$emit('on-update-item', data);
    },
    async handleClearRemark() {
      this.$emit('on-loading', true);
      let res = false;
      if (this.isBalance) {
        res = await updateJournal([{
          id: this.item.id,
          comment: '',
        }]);
      } else {
        res = await updateBilling([{
          id: this.item.id,
          comment: '',
        }]);
      }
      this.$emit('on-loading', false);
      if (res) {
        this.$Message.success('操作成功');
        this.$emit('on-update-item-remark', {
          ...this.item,
          comment: '',
        });
      }
    },
    handleShowContractDetail() {
      if (!this.isBalance) {
        this.$emit('on-detail-show', this.item);
      }
    },
  },
};
</script>

<style lang="less">
  .paymentc__body{
    .item{
      margin-bottom: 8px;
      .box-shadow;
      border-radius: 8px;
      background-color: #fff;
      position: relative;
      &.billing:hover{
        cursor: pointer;
        box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .1),
        0 6px 30px 5px rgba(0, 0, 0, .08),
        0 8px 10px 0 rgba(0, 0, 0, .16);
        z-index: 9;
      }
      &-body{
        padding: 8px 16px;
        height: 87px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        .ivu-row{
          margin-bottom: 16px;
          &:last-child{
            margin-bottom: 0;
          }
        }
        .label{
          color: rgba(0, 0, 0, 0.54);
          font-size: 12px;
          line-height: 24px;
        }
        .value{
          color: rgba(0, 0, 0, 0.87);
          font-size: 14px;
          line-height: 24px;
        }
      }
      &-footer{
        height: 48px;
        padding: 0 16px;
        .time{
          color: rgba(0, 0, 0, 0.26);
          font-size: 12px;
          line-height: 24px;
        }
        .detail{
          height: 24px;
          .ivu-select-arrow{
            font-size: 20px;
          }
          &.overdue{
            .ivu-select{
              color: rgb(239, 108, 0);
            }
            .ivu-select-arrow{
              color: rgb(239, 108, 0);
            }
          }
          &.topaid{
            .ivu-select{
              color: @primary-color;
            }
            .ivu-select-arrow{
              color: @primary-color;
            }
          }
          .v-icon{
            color: rgb(239, 108, 0);
          }
          .ivu-select{
            color: rgba(0, 0, 0, 0.54);
            width: 80px;
          }
          .ivu-select-selection{
            border: none;
            height: 24px;
          }
          .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
          .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
            height: 24px;
            line-height: 24px;
            font-weight: 500;
          }
          .ivu-select-visible .ivu-select-selection{
            box-shadow: none;
          }
        }
      }
      &-remark{
        position: absolute;
        right: 10px;
        top: 10px;
        color: rgba(0, 0, 0, 0.54);
        &.active{
          color: @primary-color;
        }
        .v-icon{
          cursor: pointer;
        }
        .ivu-poptip{
          .v-icon{
            color: @primary-color;
          }
        }
      }
      &-changed{
        width: 8px;
        height: 100%;
        position: absolute;
        border-bottom-left-radius: 8px;
        border-top-left-radius: 8px;
        z-index: 2;
        top: 0;
        left: 0;
        overflow: hidden;
        &-bg{
          width: 4px;
          background-color: rgb(80, 227, 194);
          height: 100%;
        }
      }
    }
  }
  .payment-item-remark-poptip{
    width: 224px;
    .ivu-poptip-content{
      box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.1),
      0 9px 46px 8px rgba(0, 0, 0, 0.08),
      0 11px 15px 0 rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      overflow: hidden;
    }
    .ivu-poptip-title{
      &:after{
        display: none;
      }
      h3{
        font-size: 22px;
        line-height: 32px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 500;
      }
      p{
        font-size: 14px;
        color: @primary-color;
        line-height: 32px;
        cursor: pointer;
        font-weight: 500;
      }
    }
    .ivu-poptip-body{
      padding: 0 16px 16px;
    }
    .ivu-poptip-body-content{
      color: rgba(0, 0, 0, 0.87);
      line-height: 20px;
      min-height: 100px;
    }
  }
</style>
